import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Room_Amenities } from '../../../../../constants/APIs';

export default class RoomAmenities extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Room_Amenities} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
